import { render, staticRenderFns } from "./RelationsAccount.vue?vue&type=template&id=9e2b4fd8&"
import script from "./RelationsAccount.vue?vue&type=script&lang=js&"
export * from "./RelationsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e2b4fd8')) {
      api.createRecord('9e2b4fd8', component.options)
    } else {
      api.reload('9e2b4fd8', component.options)
    }
    module.hot.accept("./RelationsAccount.vue?vue&type=template&id=9e2b4fd8&", function () {
      api.rerender('9e2b4fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/relations/RelationsAccount.vue"
export default component.exports